import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import SelectFuncionarios from "../../components/Funcionarios/SelectFuncionarios";
import { UrlWs } from "../../utils/Global";

export const CrearProceso = () => {
  const navigate = useNavigate();

  const [status, setStatus] = useState(false);
  const [error, setError] = useState(false);
  const [cargando, setCargando] = useState(false);

  const [funcionariosFEA, setFuncionariosFEA] = useState([]);
  const [direccionesUnidades, setDireccionesUnidades] = useState([]);

  var fetchParam = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    const getData = async () => {
      try {
        let funFeaRes = await fetch(UrlWs + "/officers/fea", fetchParam),
          dirUniRes = await fetch(
            UrlWs + "/municipal-management/listAll",
            fetchParam
          ),
          funFeaJSON = await funFeaRes.json(),
          dirUniJSON = await dirUniRes.json();
        //console.log(funFeaJSON, dirUniJSON);
        setFuncionariosFEA(funFeaJSON);
        setDireccionesUnidades(dirUniJSON);
        setStatus(true);
      } catch (error) {
        setError(true);
      }
    };

    if (!status) {
      getData();
    }
  }, [status]);

  function formatDate(date) {
    return new Date(date).toISOString().split("T")[0];
  }

  const handleSubmit = (e) => {
    setCargando(true);
    e.preventDefault();

    var process = {};
    process.name = e.target.nombre.value;
    process.yearProcess = e.target.ano.value;
    process.createdUser = "RESCOBAR";

    var qualifyingBoard = {};
    qualifyingBoard.presidentJC = e.target.presidente.value;
    qualifyingBoard.secretaryJC = e.target.secretario.value;
    qualifyingBoard.representativeFuncJC = e.target.representanteFun.value;
    qualifyingBoard.memberUnoJC = e.target.integranteUno.value;
    qualifyingBoard.memberDosJC = e.target.integranteDos.value;
    qualifyingBoard.presidentAsoccFuncJC = e.target.representanteAsoc.value;
    process.qualifyingBoard = qualifyingBoard;

    process.qualificationStages = [
      {
        stage: 1,
        starDate: formatDate(e.target.fecha_ini_etapa1.value),
        endDate: formatDate(e.target.fecha_fin_etapa1.value),
      },
      {
        stage: 2,
        starDate: formatDate(e.target.fecha_ini_etapa2.value),
        endDate: formatDate(e.target.fecha_fin_etapa2.value),
      },
      {
        stage: 3,
        starDate: formatDate(e.target.fecha_ini_etapa3.value),
        endDate: formatDate(e.target.fecha_fin_etapa3.value),
      },
      {
        stage: 4,
        starDate: formatDate(e.target.fecha_ini_etapa4.value),
        endDate: formatDate(e.target.fecha_fin_etapa4.value),
      },
    ];

    var preQualifiers = [];
    direccionesUnidades.map((item, i) => {
      var idDireccion = item.id_Dmunicipal;

      preQualifiers.push({
        id_municipalManagement: idDireccion,
        id_municipalUnit: null,
        id_officer: document.getElementById("direcPrec_" + idDireccion).value,
      });

      item.umunicipal.map((item, i) => {
        preQualifiers.push({
          id_municipalManagement: idDireccion,
          id_municipalUnit: item.id_Umunicipal,
          id_officer: document.getElementById("uniPrec_" + item.id_Umunicipal)
            .value,
        });
      });
    });

    process.prequalifiers = preQualifiers;

    // Crear Proceso
    async function save(data) {
      try {
        const url = UrlWs + "/process";
        let response = await fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        }).then((response) => {
          console.log(response);
          setCargando(false);
          if (response.status === 201) {
            Swal.fire({
              title: "Listo!",
              text: "Proceso creado con éxito.",
              icon: "success",
              confirmButtonText: "Ok",
            }).then(() => {
              navigate("/buscarProceso");
            });
          }
          if (response.status === 400) {
            console.log(response);
            Swal.fire({
              title: "Error!",
              text: "Ya existe un proceso abierto. Favor cierrelo para poder continuar.",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      } catch (error) {
        setCargando(false);
        console.log(error);
        setError(true);
      }
    }
    save(process);
  };

  return (
    <>
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
              Crear
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark">
                Crear Proceso de Calificación
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>
      <form
        data-kt-search-element="advanced-options-form"
        className="pt-1"
        onSubmit={handleSubmit}
      >
        <div className="post d-flex flex-column-fluid mt-5" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                        INFORMACIÓN DEL PROCESO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row mb-8">
                      <div className="col-6">
                        <select
                          name="ano"
                          required
                          className="form-select mb-5"
                          aria-label="Select example"
                        >
                          <option value="">Año del proceso</option>
                          <option value={2023}>2023</option>
                          <option value={2024}>2024</option>
                          <option value={2025}>2025</option>
                          <option value={2026}>2026</option>
                          <option value={2027}>2027</option>
                        </select>
                      </div>
                      <div className="col-6">
                        <input
                          name="nombre"
                          required
                          type="text"
                          className="form-control mb-5"
                          placeholder="Nombre del Proceso"
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          Nombre de la Etapa:
                        </label>
                        <input
                          type="text"
                          className="form-control mb-5"
                          placeholder="Evaluación Cuatrimestral (sep/dic)"
                          disabled
                        />
                      </div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-6">
                            <label className="form-label">Fecha Inicio:</label>
                            <input
                              type="date"
                              name="fecha_ini_etapa1"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                          <div className="col-6">
                            <label className="form-label">Fecha Fin:</label>
                            <input
                              type="date"
                              name="fecha_fin_etapa1"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          className="form-control mb-5"
                          placeholder="Evaluación Cuatrimestral (ene/abr"
                          disabled
                        />
                      </div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-6">
                            <input
                              type="date"
                              name="fecha_ini_etapa2"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                          <div className="col-6">
                            <input
                              type="date"
                              name="fecha_fin_etapa2"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          className="form-control mb-5"
                          placeholder="Precalificación Anual (sep/ago)"
                          disabled
                        />
                      </div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-6">
                            <input
                              type="date"
                              name="fecha_ini_etapa3"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                          <div className="col-6">
                            <input
                              type="date"
                              name="fecha_fin_etapa3"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          className="form-control mb-5"
                          placeholder="Calificación"
                          disabled
                        />
                      </div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-6">
                            <input
                              type="date"
                              name="fecha_ini_etapa4"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                          <div className="col-6">
                            <input
                              type="date"
                              name="fecha_fin_etapa4"
                              className="form-control mb-5"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <div className="card-title flex-column">
                          <h3 className="mb-5">DEFINIR JUNTA CALIFICADORA</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <div className="mb-5">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Presidente:
                          </label>
                          <SelectFuncionarios
                            list={funcionariosFEA}
                            name="presidente"
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-5">
                          <label className="form-label">Secretario:</label>
                          <SelectFuncionarios
                            list={funcionariosFEA}
                            name="secretario"
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-5">
                          <label className="form-label">
                            Representante Funcionarios:
                          </label>
                          <SelectFuncionarios
                            list={funcionariosFEA}
                            name="representanteFun"
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-5">
                          <label className="form-label">
                            Representante Asociacion:
                          </label>
                          <SelectFuncionarios
                            list={funcionariosFEA}
                            name="representanteAsoc"
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-5">
                          <label className="form-label">Integrante Uno:</label>
                          <SelectFuncionarios
                            list={funcionariosFEA}
                            name="integranteUno"
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-5">
                          <label className="form-label">Integrante Dos:</label>
                          <SelectFuncionarios
                            list={funcionariosFEA}
                            name="integranteDos"
                            required={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         DEFINIR PRE CALIFICADORES DEL PROCESO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    {direccionesUnidades!=[] ? direccionesUnidades.map((item, i) => {
                      return (
                        <>
                          <div className="row">
                            <div className="col-8">
                              <div className="mb-5">
                                <label className="form-label">
                                  Nombre dirección
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={item.nameDmunicipal}
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="col-4">
                              <div className="mb-5">
                                <label className="form-label">
                                  Asignar Precalificador
                                </label>
                                <SelectFuncionarios
                                  list={funcionariosFEA}
                                  idValue={`direcPrec_${item.id_Dmunicipal}`}
                                  required={true}
                                  selectedID={12}
                                />
                              </div>
                            </div>
                          </div>

                          {item.umunicipal.map((item, i) => {
                            return (
                              <div className="row">
                                <div className="col-2">
                                  <div className="mb-5">
                                    <label className="form-label">
                                      Nombre Unidad
                                    </label>
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="mb-5">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={item.nameUmunicipal}
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="mb-5">
                                    <SelectFuncionarios
                                      list={funcionariosFEA}
                                      idValue={`uniPrec_${item.id_Umunicipal}`}
                                      required={true}
                                      selectedID={12}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          <div className="separator separator-dashed my-3"></div>
                        </>
                      );
                    }) : <>Cargando direcciones...</>}

                    <div className="row float-end">
                      <div className="col-12">
                        <input
                          type="submit"
                          value={
                            cargando ? "Creando proceso..." : "Crear Proceso"
                          }
                          className="btn btn-primary"
                          disabled={cargando}
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
